import React from 'react';
import { Plus, Edit2, Trash2, Check, X, Save, RefreshCw, Download, Eye, CheckCircle, XCircle, AlertCircle, LogIn } from 'react-feather';
import { UiButton } from '../../components/UiButton';

const allColors = [
    'azul', 'azul-royal', 'indigo', 'violeta', 'roxo', 'rosa',
    'vermelho', 'laranja', 'ambar', 'amarelo', 'lima', 'verde',
    'esmeralda', 'teal', 'ciano', 'azul-ceu',
    'slate', 'cinza', 'zinc', 'stone', 'escuro', 'quase-preto',
    'claro', 'branco',
];

const semantics = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'];

const realButtons = [
    { label: 'Adicionar',             icon: Plus,        variant: 'primary'   },
    { label: 'Editar',                icon: Edit2,       variant: 'secondary' },
    { label: 'Remover',               icon: Trash2,      variant: 'danger'    },
    { label: 'Salvar',                icon: Save,        variant: 'success'   },
    { label: 'Cancelar',              icon: X,           variant: 'light'     },
    { label: 'Confirmar',             icon: Check,       variant: 'success'   },
    { label: 'Cadastrar Cliente',     icon: Plus,        variant: 'primary'   },
    { label: 'Exportar Relatório',    icon: Download,    variant: 'secondary' },
    { label: 'Visualizar Contrato',   icon: Eye,         variant: 'info'      },
    { label: 'Sincronizar Bling',     icon: RefreshCw,   variant: 'dark'      },
    { label: 'Ativar',                icon: CheckCircle, variant: 'success'   },
    { label: 'Desativar',             icon: XCircle,     variant: 'warning'   },
    { label: 'Aprovar Orçamento',     icon: Check,       variant: 'success'   },
    { label: 'Recusar',               icon: AlertCircle, variant: 'danger'    },
    { label: 'Entrar no Sistema',     icon: LogIn,       variant: 'primary'   },
];

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, color: '#94a3b8', textTransform: 'uppercase', marginBottom: 10 }}>
            {title}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}>
            {children}
        </div>
    </div>
);

const Divider = () => <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '4px 0' }} />;

export default function ButtonsSandbox() {
    return (
        <div style={{ padding: 32, display: 'flex', flexDirection: 'column', gap: 24, overflowY: 'auto', height: '100%' }}>

            <Section title="Todas as cores — solid sm">
                {allColors.map(c => (
                    <UiButton key={c} variant={c} size="sm">{c}</UiButton>
                ))}
            </Section>

            <Section title="Todas as cores — outline sm">
                {allColors.map(c => (
                    <UiButton key={c} variant={c} size="sm" outline>{c}</UiButton>
                ))}
            </Section>

            <Divider />

            <Section title="Aliases semânticos — solid">
                {semantics.map(s => (
                    <UiButton key={s} variant={s}>{s}</UiButton>
                ))}
            </Section>

            <Section title="Aliases semânticos — outline">
                {semantics.map(s => (
                    <UiButton key={s} variant={s} outline>{s}</UiButton>
                ))}
            </Section>

            <Divider />

            <Section title="Botões reais — sm">
                {realButtons.map(({ label, icon: Icon, variant }) => (
                    <UiButton key={label} variant={variant} size="sm">
                        <Icon size={12} />{label}
                    </UiButton>
                ))}
            </Section>

            <Section title="Botões reais — md">
                {realButtons.map(({ label, icon: Icon, variant }) => (
                    <UiButton key={label} variant={variant}>
                        <Icon size={14} />{label}
                    </UiButton>
                ))}
            </Section>

            <Section title="Botões reais — disabled">
                {realButtons.slice(0, 8).map(({ label, icon: Icon, variant }) => (
                    <UiButton key={label} variant={variant} size="sm" disabled>
                        <Icon size={12} />{label}
                    </UiButton>
                ))}
            </Section>

        </div>
    );
}
